module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAABCAYAAAAFKSQHAAAAAXNSR0IArs4c6QAAABBJREFUCB1jZGBg+A/EJAEAMTkBAVhvfDMAAAAASUVORK5CYII="